@switch (icon.kind) {
  @case ('fa') {
    <i [ngClass]="faClasses"></i>
  }
  @case ('svg') {
    <shared-svg-icon [icon]="svgName"></shared-svg-icon>
  }
}
